import React, { Component } from "react";
import OCPList from "./OCPList";

class ProformaList extends Component {
  render() {
    return <OCPList module="Proforma" entryPage="ProformaEntry" />;
  }
}

export default ProformaList;
